// import { LadyLookingAtPhone } from "../assets/img";
import { LayoutProps } from "./types/layout.types";
import GlobalLayout from "./GlobalLayout";
import { Ban } from "lucide-react";
import { Link } from "react-router-dom";

const AuthLayout = ({ children, title = "" }: LayoutProps) => (
  <GlobalLayout title={title}>
    <main className="grid lg:grid-cols-6 w-full lg:w-11/12 xl:w-7/12 mx-auto lg:pt-8 h-[100vh] sm:hidden block">
      {/* side image  */}
      {/* <section className="hidden lg:block lg:col-span-3">
        <img
          src={LadyLookingAtPhone}
          alt="Lady Looking At Phone"
          className="w-10/12 lg:w-10/12"
        />
      </section> */}

      {/* child compoent for auth screens */}
      <section className="lg:col-span-3 sm:hidden block">{children}</section>
    </main>

    <div className="sm:flex hidden items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center w-80 text-center">
        <Ban className="w-12 h-12 text-red-500" />
        <h2 className="text-lg font-semibold mt-4">
          Honneconnect Not Available
        </h2>
        <p className="text-gray-600 mt-2">
          This feature is not available on this device screen. Kindly use a
          mobile phone.
        </p>
        <Link to="/" className="text-blue-800 text-xs">
          Go Home
        </Link>
      </div>
    </div>
  </GlobalLayout>
);

export default AuthLayout;
